module.exports = __webpack_public_path__ + "static/media/Montserrat-Regular.08a754d1.ttf";